<template>
    <v-alert
        :type="incoming.type ?? 'error'"
        class="my-2 text-start"
        variant="tonal"
        :closable="closable"
    >
        {{ incoming.message }}
    </v-alert>
</template>

<script lang="ts" setup>

import { defineProps } from 'vue';

interface Props {
    message: string;
    closable?: boolean;
    type?: 'error' | 'warning' | 'info' | 'success';
}

const incoming = defineProps<Props>();
const closable = incoming.closable ?? true; 
</script>